<script>
    export let style = "";
</script>

<div {style} class="sheet">
    <slot />
</div>

<style>
    /* ☁️ Elevation */
    .sheet {
        height: 100%;
        overflow: hidden;
        /* Elevation Overlay / 08dp */
        background: var(--color-level-1);
        box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14),
            0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
    }
</style>
